module.exports = __webpack_public_path__ + "img/2 mario-hidalgo-circulo.ef852b08.png";